"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParam = exports.smsHref = exports.mailTo = exports.toRelativeUrl = exports.useQuery = exports.queryParams = void 0;
var react_1 = require("react");
var browser_1 = require("./browser");
var queryParams = function () {
    return new URLSearchParams((0, browser_1.isBrowser)() ? window.location.search : {});
};
exports.queryParams = queryParams;
var useQuery = function () {
    return (0, exports.queryParams)();
};
exports.useQuery = useQuery;
var toRelativeUrl = function (path, query) {
    if (typeof query !== typeof URLSearchParams)
        query = new URLSearchParams(query);
    return "".concat(path, "?").concat(query.toString());
};
exports.toRelativeUrl = toRelativeUrl;
var mailTo = function (email, _a) {
    var _b = _a === void 0 ? {} : _a, subject = _b.subject;
    var link = "mailto:".concat(email);
    if (subject) {
        link = "".concat(link, "?subject=").concat(encodeURIComponent(subject));
    }
    return link;
};
exports.mailTo = mailTo;
var smsHref = function (body) {
    return "sms:?&body=".concat(encodeURIComponent(body));
};
exports.smsHref = smsHref;
var useQueryParam = function (paramName, navigate, render) {
    var _a = (0, react_1.useState)(0), counter = _a[0], setChanged = _a[1];
    var pathname = (0, browser_1.isBrowser)() ? window.location.pathname : '';
    var query = (0, exports.queryParams)();
    var paramValue = query.get(paramName);
    var getUrl = function (newVal) {
        var newQuery = new URLSearchParams(query);
        newVal ? newQuery.set(paramName, newVal) : newQuery.delete(paramName);
        return (0, exports.toRelativeUrl)(pathname, newQuery);
    };
    var setParam = function (newVal) {
        setChanged(counter + 1);
        navigate(getUrl(newVal));
    };
    return __assign({ setParam: setParam, getUrl: getUrl, paramValue: paramValue }, (render && { rendered: render({ paramValue: paramValue, setParam: setParam }) }));
};
exports.useQueryParam = useQueryParam;
//# sourceMappingURL=routes.js.map